// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xScreen } from "@awc/XDL/Utilities";
import { assignBudgetsStyles } from "@insite/content-library/Widgets/Budget/AssignBudgets";
import { FormInputWrapper } from "@insite/mobius/FormField";
import { css } from "styled-components";

assignBudgetsStyles.gridContainer = {
    gap: 20,
};

assignBudgetsStyles.titleText = {
    variant: "h1",
    as: "h1",
    css: css`
        ${xScreen("lte", "sm")} {
            margin-bottom: 10px;
        }
    `,
} as any;

assignBudgetsStyles.titleGridItem = {
    width: [12, 12, 8, 8, 8],
    css: css`
        padding-bottom: 0;
    `,
};

assignBudgetsStyles.enforcementLevelGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
        padding-top: 0;
    `,
};

assignBudgetsStyles.wrapper = {
    css: css`
        display: inline-block;
        margin-right: 22px;
        margin-bottom: 0;
    `,
};

assignBudgetsStyles.filterGridItem = {
    width: 12,
    css: css`
        display: block;
    `,
};

assignBudgetsStyles.budgetYearGridItem = { width: 12 };
assignBudgetsStyles.createBudgetGridItem = { width: 12 };
assignBudgetsStyles.assignBudgetInstructionsGridItem = { width: 12 };

assignBudgetsStyles.searchUserWrapper = {
    css: css`
        display: inline-block;
        width: calc(25% - 16px);
        ${FormInputWrapper} {
            & > div {
                width: auto;
            }
        }
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};

assignBudgetsStyles.tableGridItem = {
    width: [12, 12, 12, 12, 6],
    css: css`
        > div {
            overflow-x: hidden;
        }
    `,
};

assignBudgetsStyles.saveButton = {
    css: css`
        margin-left: 16px;
    `,
};

assignBudgetsStyles.budgetYearSelect = {
    css: css`
        min-width: 204px;
    `,
};

assignBudgetsStyles.buttonsGridItem = {
    width: [12, 12, 4, 4, 4],
    css: css`
        justify-content: flex-end;
        ${xScreen("lte", "sm")} {
            justify-content: flex-start;
        }
    `,
};

assignBudgetsStyles.cancelButton = {
    variant: "tertiary",
};

assignBudgetsStyles.budgetAmountTextField = {
    cssOverrides: {
        formInputWrapper: css`
            width: 150px;
            ${xScreen("lte", "sm")} {
                width: calc(100% - 8px);
            }
        `,
        inputSelect: css`
            padding-right: 10px;
            &:focus {
                padding-right: 10px;
            }
        `,
    },
};
